import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { DialogActions } from '@mui/material';

const dialogContentStyles = {
  px: { md: 'initial', xs: 0 },
};
const boxStyles = {
  width: { md: 760, xs: '100%' },
};

const WizardLayout = ({ buttons, children, onClose }) => {
  return (
    <>
      <AppBar elevation={1} sx={{ backgroundColor: 'surface.white' }}>
        <Toolbar disableGutters sx={{ px: 1 }} variant="dense">
          <Typography noWrap sx={{ flexGrow: 1 }} variant="h6">
            Create New Batch
          </Typography>
          <IconButton onClick={onClose} size="medium" sx={{ color: 'graphic.icons' }}>
            <CloseRoundedIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent sx={dialogContentStyles} variant="batchCreation">
        <Box mt={6.5} mx="auto" sx={boxStyles}>
          {children}
        </Box>
      </DialogContent>
      <DialogActions sx={{ boxShadow: 7, p: 3 }}>{buttons}</DialogActions>
    </>
  );
};

WizardLayout.propTypes = {
  buttons: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default WizardLayout;
